module.exports = __webpack_public_path__ + "static/media/07_thechariot.e5b7263d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/07_thechariot.png
// module id = 70
// module chunks = 0